// extracted by mini-css-extract-plugin
export default {"root":"Loader__root--FqxO9C","sk-scaleout":"Loader__sk-scaleout--MwyscA"};